import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProductDetailViewModel } from '@models/api-search.models';
import { GetSplashesPipe } from '@features/product/pipes/get-splashes.pipe';
import { IsPreOrderPipe } from '@features/product/pipes/is-pre-order.pipe';
import { GetPrioritySplashPipe } from '@features/product/pipes/get-priority-splash.pipe';
import { LowerCaseFirstLetterPipe } from '@shared/text-pipes/lower-case-first-letter.pipe';
import { NormalizePropertiesPipe } from '@shared/product-details-pipes/normalize-properties.pipe';
import { TranslateSafePipe } from '@shared/translate-safe/translate-safe.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { SafePipe } from '@shared/safe/safe.pipe';
import { InterceptLinksDirective } from '@shared/intercept-links/intercept-links.directive';
import { ProductSpecificationsComponent } from '@features/product-detail/product-specifications/product-specifications.component';
import { AccordionComponent } from '@shared/accordion/accordion.component';
import { DatePipe, KeyValuePipe, NgFor, NgIf } from '@angular/common';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { SameDayDeliveryComponent } from '@shared/same-day-delivery/same-day-delivery/same-day-delivery.component';
import { SameDayDeliveryInOffModeDirective } from '@shared/same-day-delivery/same-day-delivery-in-off-mode.directive';

@Component({
    selector: 'app-product-information',
    templateUrl: './product-information.component.html',
    styleUrls: ['./product-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        AccordionComponent,
        ProductSpecificationsComponent,
        NgFor,
        InterceptLinksDirective,
        DatePipe,
        KeyValuePipe,
        SafePipe,
        TranslateModule,
        TranslateSafePipe,
        NormalizePropertiesPipe,
        LowerCaseFirstLetterPipe,
        GetPrioritySplashPipe,
        IsPreOrderPipe,
        GetSplashesPipe,
        SvgIconComponent,
        SameDayDeliveryComponent,
        SameDayDeliveryInOffModeDirective
    ]
})
export class ProductInformationComponent {
    @Input() product: ProductDetailViewModel | null;
}
